import { Button, Image, StackProps, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import nowallet from '/images/img_connectwallet@2x.png'
import img_nodata from '/images/img_nopositions@2x.png'

interface NoDataProps extends StackProps {
  type: 'nowallet' | 'nodata' | 'custom' | ''
  noBorder?: boolean
  children?: React.ReactNode
  onboard?: () => void
  text?: string
  imgUrl?: string
  noImg?: boolean
}

export default function NoData(props: NoDataProps) {
  const { type, noBorder, text, children, onboard, imgUrl, noImg, ...rest } = props
  return (
    <VStack
      w="100%"
      h="auto"
      background="bg_secondary"
      gap="4px"
      p="40px"
      align="center"
      justifyContent="center"
      borderRadius="12px"
      border="1px solid"
      borderColor={noBorder ? 'transparent' : 'border'}
      {...rest}
    >
      {!noImg && <Image w="160px" h="160px" mb="-12px" src={type == 'nodata' ? img_nodata : type == 'nowallet' ? nowallet : imgUrl ? imgUrl : ''} />}
      {type == 'nowallet' ? (
        <Button
          borderRadius="8px"
          fontWeight="500"
          w="120px"
          h="36px"
          fontSize="12px"
          onClick={(e: any) => {
            if (onboard) {
              onboard()
            }
            e.target.blur()
          }}
        >
          Connect Wallet
        </Button>
      ) : type !== 'custom' ? (
        <Text color="text_caption" textAlign="center" fontWeight="500">
          {!text ? 'No Data' : text}
        </Text>
      ) : null}
      {children}
    </VStack>
  )
}
